/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component (per-participant ski-level color-picker actions)
 *   extends:   Component (@glimmer/component)
 *   template:  level-selector.hbs
 *   args:      @setLevel, @dispo
 *   uses:      -
 *   siblings:  list-levels, render-level
 *   tests:     glimmer-actions-test.js, level-selector-writes-test.js
 *
 * Sets/clears a contact's tracked `tmpLevel` and forwards the pick to the host
 * via @setLevel; also toggles a level's sotto_livelli disclosure.
 */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { set } from '@ember/object';

export default class LevelSelectorComponent extends Component {
  @action
  removeColor(contact, event) {
    event.preventDefault();
    set(contact, 'tmpLevel', null);
    this.args.setLevel(contact, this.args?.dispo, null);
  }

  @action
  setColor(contact, level, event) {
    event.preventDefault();
    set(contact, 'tmpLevel', level);
    this.args.setLevel(contact, this.args?.dispo, level);
  }

  @action
  toggleSottoLivelli(level, event) {
    event.preventDefault();
    set(level, 'showSottoLivelli', !level.showSottoLivelli);
  }
}
